var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('h3',[_c('t-icon-label',{attrs:{"icon":`el-icon-${_vm.type.icon}`}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)]),_c('div',{staticClass:"m-t m-b"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }